<template>
  <router-view></router-view>
</template>

<script>
import store from "../store";
import Vue from "vue";

function applySystem() {
  const system = store.state.system.system;
  //1. 标题
  document.title = system.browserTitle;
  //2. favicon
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = system.favico;
  //3. meta description
  let metaDesc = document.querySelector("meta[name='description']");
  if (!metaDesc) {
    metaDesc = document.createElement("meta");
    metaDesc.name = "description";
    metaDesc.lang = "zh-CN";
    document.head.appendChild(metaDesc);
  }
  metaDesc.content = system.metaDescription;
  //4. meta keywords
  let metaKey = document.querySelector("meta[name='keywords']");
  if (!metaKey) {
    metaKey = document.createElement("meta");
    metaKey.name = "keywords";
    document.head.appendChild(metaKey);
  }
  metaKey.content = system.keywords;
  //5. 设置图标链接
  if (system.fonturl) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = system.fonturl;
    document.head.appendChild(link);
  }
  //6. 设置原型
  Vue.prototype.$setTitle = function(title = "") {
    if (title) {
      document.title = title + "-" + system.browserTitle;
    } else {
      document.title = system.browserTitle;
    }
  };

  Vue.prototype.$setMetaDescription = function(desc = "") {
    if (desc) {
      metaDesc.content = desc;
    } else {
      metaDesc.content = system.metaDescription;
    }
  };

  Vue.prototype.$setKeywords = function(keywords = "") {
    if (keywords) {
      metaKey.content = keywords + "," + system.metaDescription;
    } else {
      metaKey.content = system.keywords;
    }
  };
}

export default {
  beforeCreate() {
    applySystem();
  }
};
</script>
